<template>
  <div>
    <div class="css-grid battery-order-form__row battery-order-form__row--header battery-order-form__row--error">
      <div></div>
      <div class="battery-order-view__cell battery-order-view__cell--header">Order Error</div>
      <div></div>
    </div>

    <div class="panel">
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div class="battery-order__message battery-order__message--error">
          Transaction failed, please update order information and try again. If problem persists, please contact your regional team for assistance.
        </div>
        <div></div>
      </div>
    </div>

    <div class="battery-store__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="nextStep">Edit Order Info</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorMessageView',
    methods: {
      nextStep() {
        this.$store.dispatch('batteryStore/setProperty', { key: 'currentSection', value: 'shippingInfo'});
      },
    },
  }
</script>
